export default __webpack_public_path__ + "static/media/info-focus.ac5fcb4e.jpg";